import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from "react";
import { IndicatorLegend } from "../../../lib/core";
import { IconEye, IconEyeOff, IconSettings, IconX } from "../../components/common/Icons";
import { buildLegendSeriesValue } from "./overlayHelpers";
// Shared legend chrome (icons + i18n labels) so the embedded legend and the
// statusline compare node render byte-identical chips. Split from
// useWidgetOverlays (D0 headroom).
export function useLegendChrome(t) {
    return useMemo(() => ({
        icons: {
            eye: _jsx(IconEye, { size: 10 }),
            eyeOff: _jsx(IconEyeOff, { size: 10 }),
            edit: _jsx(IconSettings, { size: 10 }),
            remove: _jsx(IconX, { size: 10 }),
        },
        labels: {
            showIndicatorTitle: t("legend.show"),
            hideIndicatorTitle: t("legend.hide"),
            removeIndicatorTitle: t("legend.remove"),
            editIndicatorTitle: t("legend.edit"),
            showIndicatorAriaLabel: (seriesLabel) => `${t("legend.show")} ${seriesLabel}`,
            hideIndicatorAriaLabel: (seriesLabel) => `${t("legend.hide")} ${seriesLabel}`,
            removeIndicatorAriaLabel: (seriesLabel) => `${t("legend.remove")}: ${seriesLabel}`,
            editIndicatorAriaLabel: (seriesLabel) => `${t("legend.edit")}: ${seriesLabel}`,
        },
    }), [t]);
}
// Compare-only legend node for the statusline slot. Split from
// useWidgetOverlays (D0 headroom).
export function useCompareLegendNode(deps) {
    const { compareLegendSlot, visiblePanes, legendPanes, localizePane, legendSeriesSuffix, handlePaneToggleSeries, handlePaneRemoveSeries, handlePaneEditSeries, legendChrome, hoveredDatum, } = deps;
    return useCallback((paneId) => {
        if (compareLegendSlot !== "statusline")
            return null;
        const pane = visiblePanes.find((p) => p.id === paneId);
        if (!pane)
            return null;
        const legendPane = legendPanes?.find((lp) => lp.id === paneId) ?? localizePane(pane);
        if (!legendPane.series.some((s) => String(s.type) === "Comparison"))
            return null;
        const paneSuffix = legendSeriesSuffix ? (idx) => legendSeriesSuffix(pane.id, idx) : undefined;
        return (_jsx(IndicatorLegend, { pane: legendPane, onToggleSeries: (seriesType, seriesIndex) => handlePaneToggleSeries(pane.id, seriesType, seriesIndex), onRemoveSeries: (seriesType, seriesIndex) => handlePaneRemoveSeries(pane.id, seriesType, seriesIndex), onEditSeries: () => handlePaneEditSeries(pane.id), icons: legendChrome.icons, labels: legendChrome.labels, seriesSuffix: paneSuffix, seriesValue: hoveredDatum ? (_seriesType, idx) => buildLegendSeriesValue(hoveredDatum, legendPane.series[idx]) : undefined, embedded: true, visibleTypes: ["Comparison"] }));
    }, [compareLegendSlot, visiblePanes, legendPanes, localizePane, legendSeriesSuffix, handlePaneToggleSeries, handlePaneRemoveSeries, handlePaneEditSeries, legendChrome, hoveredDatum]);
}
